import React, { memo, useEffect, useState } from "react";
import { TabContent, TabPane } from "reactstrap";
import ObInvestmentOpportunitiesMain from "./ObInvestmentOpportunitiesMain";
import { useParams } from "react-router";
import { userProfileService } from "../../user/services/profile";
// import { Mixpanel } from "./MixPanel";
import ConsultBanner from "./ConsultBanner";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import ReactGA from "react-ga4";
// import KYC_PopUp from "./KYC_PopUp";
// import useHypervergeVerification from './HypervergeHook';
// import HypervergeSuccessPopUp from "./HypervergeSuccessPopUp";
// import HypervergeFailurePopUp from "./HypervergeFailurePopUp";
// import HypervergeUserCancelPopUp from "./HypervergeUserCancelPopUp";

const OrobondsMain = memo(function OrobondsMain(props) {
  // const { hypervergeVerification, hypervergeSuccess, toggleHypervergeFailure, hypervergeFailure, toggleHypervergeSuccess, loaderHyperverge, errorsHyperverge, userCancelled, toggleUserCancelled, reinitiateHyperverge } = useHypervergeVerification();
  const [activeTab, setActiveTab] = useState("invest");
  const { tab } = useParams();
  const [utm, setUtm] = useState();
  // const [kycPopUp, setKycPopUp] = useState(false);
  // const [kycKraData, setKycKraData] = useState([]);

  // const toggleKycPopUp = () => {
  //   setKycPopUp(!kycPopUp);
  // };

  useEffect(() => {
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent("SignUpComplete");
    }
  }, []);

  // const reInitiateHyperverge = () => {
  //   reinitiateHyperverge()
  //   hypervergeVerification();
  // }

  // const inititateHyper = () => {
  //   hypervergeVerification();
  //   setKycPopUp(!kycPopUp)
  // }

  useEffect(() => {
    let utm = "";
    if (tab) {
      let utm_params = new URLSearchParams(tab.split("?")[1]);
      if (utm_params.get("utm_source")) {
        utm = tab;
        setUtm(tab);
      } else {
        setActiveTab(tab.split("=")[1]);
      }
    } else if (localStorage.getItem("utmParams")) {
      utm = localStorage.getItem("utmParams");
    }
    let source = "web";
    if (!sessionStorage.getItem("userInterest")) {
      let userInterest = "Invest - Orobonds";
      userProfileService.sentUserData(source, userInterest, utm).then((res) => {
        if (res?.success) {
          sessionStorage.setItem("userInterest", userInterest);
        }
      });
    }
  }, []);

  useEffect(() => {
    window.location.replace(`${process.env.REACT_APP_BASE_URL_ICM}/platforms/listing`);
    const locationHash = window.location.hash;
    ReactGA.send({ hitType: "pageview", page_location: `${locationHash}` });
    {
      process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(locationHash, `${locationHash}`);
    }
  }, []);

  useEffect(() => {
    if (props.userEmail) {
      /* Mixpanel.track("p_screener", {
        // "Name": props.name,
        "Email id": props.userEmail,
      }); */
    }
  }, [props.userEmail]);

  return (
    null
    // <>
    //   <div className="orobonds-main">
    //     <TabContent activeTab={activeTab}>
    //       <TabPane key={"tab-" + activeTab} tabId={activeTab}>
    //         {props?.portfolioDetails && props?.userEmail &&
    //           <ObInvestmentOpportunitiesMain
    //             portfolioDetails={props.portfolioDetails}
    //             userEmail={props && props.userEmail ? props.userEmail : ""}
    //             utm={utm}
    //           />
    //         }
    //       </TabPane>
    //       {props?.showConsultbanner ? (
    //         <ConsultBanner closeConsultBanner={props?.closeConsultBanner} />
    //       ) : null}
    //     </TabContent>
    //   </div>

    //   {/* {kycPopUp ? (
    //     <KYC_PopUp
    //       kycPopUp={kycPopUp}
    //       toggleKycPopUp={toggleKycPopUp}
    //      initiateHyperverge={inititateHyper}
    //       kycKraData={kycKraData}
    //     />
    //   ) : null}
    //   {hypervergeSuccess ? (
    //     <HypervergeSuccessPopUp
    //       errorsHyperverge={errorsHyperverge}
    //       toggleHypervergeSuccess={toggleHypervergeSuccess}
    //       reInitiateHyperverge={reInitiateHyperverge}
    //       hypervergeSuccess={hypervergeSuccess}
    //     />
    //   ) : null}
    //   {hypervergeFailure ? (
    //     <HypervergeFailurePopUp
    //       toggleHypervergeFailure={toggleHypervergeFailure}
    //       hypervergeFailure={hypervergeFailure}
    //     />
    //   ) : null}

    //   {userCancelled ? (
    //     <HypervergeUserCancelPopUp
    //       toggleUserCancelled={toggleUserCancelled}
    //       reInitiateHyperverge={reInitiateHyperverge}
    //       userCancelled={userCancelled}
    //     />
    //   ) : null} */}
    // </>
  );
});

export default OrobondsMain;